import { useEffect, useState } from "react";

function pad(n: number) { return String(n).padStart(2, "0"); }

export function LiveClock({ className = "" }: { className?: string }) {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  const h = pad(now.getHours());
  const m = pad(now.getMinutes());
  const s = pad(now.getSeconds());

  return (
    <div className={`text-right ${className}`}>
      <p className="text-2xl font-bold tabular-nums leading-none tracking-tight text-gray-800">
        {h}:{m}<span className="text-gray-400 text-xl">:{s}</span>
      </p>
      <p className="text-xs text-gray-400 capitalize mt-0.5">
        {now.toLocaleDateString("es-VE", { weekday: "long", day: "numeric", month: "long" })}
      </p>
    </div>
  );
}
